import {
  CHANGE_SEARCH,
  UPDATE_REALTY_OFFERS,
  UPDATE_REALTY_OFFERS_PRIMARY,
  UPDATE_INPUT_INTERVALS_PRIMARY,
  CLEAR_FILTERS_PRIMARY,
  SET_LAUNCHING_YEARS,
  SET_CONSTRUCTION_PATTERN,
  SET_STATUS,
  SET_BUILDINGS,
  SET_COMPANIES,
  UPDATE_BUILDING_DATA,
  UPDATE_REQUEST_STATUS,
  UPDATE_DISPLAY_PRIMARY_CHARTS,
  SET_INFOWINDOWS_PRIMARY,
  ADD_INFOWINDOWS_PRIMARY,
  REMOVE_ALL_INFOWINDOWS_PRIMARY,
  CLOSE_INFOWINDOWS_PRIMARY,
  SET_FILTERED_BUILDINGS,
  SET_FILTERED_COMPANIES,
  UPDATE_DISPLAY_BIG_NUMBERS_PRIMARY,
  SET_DISPLAY_GENERAL_CHARTS,
  UPDATE_CHARTS_DATA_PRIMARY,
  SET_PDF_IMAGES,
} from './offersPrimary.actions';

const realtyOffersFiltersOptions = {
  launchingYears: [],
  constructionPattern: [],
  realtyTypes: [
    { name: 'Apartamento', id: 'ap' },
    { name: 'Casa', id: 'cs' },
    { name: 'Comercial', id: 'comm' },
  ],
  timeframe: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  privateAreaInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  valueInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  bedrooms: [
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  unitPrice: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  realtyAge: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  status: '',
  buildings: [],
  companies: [],
};

const initialFiltersPrimary = {
  realtyType: { name: 'Apartamento', id: 'ap' },
  inputIntervals: {
    timeframe: { min: '', max: '' },
    privateAreaInterval: { min: '', max: '' },
    pricePerSquareMt: { min: '', max: '' },
    unitPrice: { min: '', max: '' },
  },
  bedrooms: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  selectedConstructionPattern: [],
  selectedStatus: [],
  selectedBuildings: [],
  selectedCompanies: [],
  realStateDevelopers: [],
  buildingNames: [],
};

const initialState = {
  realtyOffersFiltersOptions,
  realtyOffersPrimary: initialFiltersPrimary,
  userInput: {
    building: '',
    company: '',
  },
  buildingData: {},
  requestStatus: {
    // INACTIVE | LOADING | LOADED | FAILED
    launchedUnits: 'INACTIVE',
    launchedUnitsEcoMapPercentile: 'INACTIVE',
    sales: 'INACTIVE',
    harvest: 'INACTIVE',
    salesEcoMap: 'INACTIVE',
    releasesSalesStock: 'INACTIVE',
    weightedAverage: 'INACTIVE',
    weightedAverageEcoMap: 'INACTIVE',
    releasesSalesStockECOMAP: 'INACTIVE',
  },
  displayGeneralCharts: true,
  chartsDataPrimary: {
    infoWindowsPrimary: [],
    filteredBuildings: [],
    filteredCompanies: [],
    eco_map: [],
    sales: [],
    launchedUnits: [],
    launchedUnitsSales: [],
    percentileOffers: [],
    percentileVGV: [],
    releasesSalesStock: [],
    weightedAverage: [],
    weightedAverageEcoMap: [],
    salesEcoMap: [],
    releasesSalesStockECOMAP: [],
  },
  pdfImages: {},
};

export default function realtyOffersReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case CHANGE_SEARCH:
      return {
        ...state,
        userInput: { ...state.userInput, [payload.name]: payload.value },
      };
    case UPDATE_REALTY_OFFERS:
      return {
        ...state,
        realtyOffers: { ...state.realtyOffers, [payload.name]: payload.value },
      };
    case UPDATE_REALTY_OFFERS_PRIMARY:
      return {
        ...state,
        realtyOffersPrimary: {
          ...state.realtyOffersPrimary,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_INPUT_INTERVALS_PRIMARY:
      return {
        ...state,
        realtyOffersPrimary: {
          ...state.realtyOffersPrimary,
          inputIntervals: {
            ...state.realtyOffersPrimary.inputIntervals,
            [payload.name]: payload.value,
          },
        },
      };
    case CLEAR_FILTERS_PRIMARY:
      return {
        ...state,
        realtyOffersPrimary: {
          ...initialFiltersPrimary,
          inputIntervals: {
            timeframe: { min: '', max: '' },
            privateAreaInterval: { min: '', max: '' },
            pricePerSquareMt: { min: '', max: '' },
            unitPrice: { min: '', max: '' },
          },
        },
      };
    case SET_LAUNCHING_YEARS:
      return {
        ...state,
        realtyOffersFiltersOptions: {
          ...state.realtyOffersFiltersOptions,
          launchingYears: payload,
        },
      };
    case SET_CONSTRUCTION_PATTERN:
      return {
        ...state,
        realtyOffersFiltersOptions: {
          ...state.realtyOffersFiltersOptions,
          constructionPattern: payload,
        },
      };
    case SET_STATUS:
      return {
        ...state,
        realtyOffersFiltersOptions: {
          ...state.realtyOffersFiltersOptions,
          status: payload,
        },
      };
    case SET_BUILDINGS:
      return {
        ...state,
        realtyOffersFiltersOptions: {
          ...state.realtyOffersFiltersOptions,
          buildings: payload,
        },
      };
    case SET_COMPANIES:
      return {
        ...state,
        realtyOffersFiltersOptions: {
          ...state.realtyOffersFiltersOptions,
          companies: payload,
        },
      };
    case UPDATE_BUILDING_DATA:
      return { ...state, buildingData: { ...state.buildingData, ...payload } };
    case UPDATE_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_DISPLAY_PRIMARY_CHARTS:
      return { ...state, displayPrimaryCharts: payload };
    case UPDATE_DISPLAY_BIG_NUMBERS_PRIMARY:
      return { ...state, displayBigNumbersPrimary: payload };
    case SET_INFOWINDOWS_PRIMARY:
      return { ...state, infoWindowsPrimary: [payload] };
    case ADD_INFOWINDOWS_PRIMARY:
      return {
        ...state,
        infoWindowsPrimary: [...state.infoWindowsPrimary, payload],
      };
    case REMOVE_ALL_INFOWINDOWS_PRIMARY:
      return { ...state, infoWindowsPrimary: [] };
    case CLOSE_INFOWINDOWS_PRIMARY:
      state.infoWindowsPrimary?.forEach((iw) => iw.close());
      return state;
    case SET_FILTERED_BUILDINGS:
      return { ...state, filteredBuildings: payload };
    case SET_FILTERED_COMPANIES:
      return { ...state, filteredCompanies: payload };
    case SET_DISPLAY_GENERAL_CHARTS:
      return { ...state, displayGeneralCharts: payload };
    case UPDATE_CHARTS_DATA_PRIMARY:
      return {
        ...state,
        chartsDataPrimary: {
          ...state.chartsDataPrimary,
          [payload.name]: payload.value,
        },
      };
    case SET_PDF_IMAGES:
      return { ...state, pdfImages: payload };
    default:
      return state;
  }
}
